"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

/**
 * Checks to see if the current environment is a browser
 * @returns boolean True if is browser false if not
 */
var isBrowserCheck = function isBrowserCheck() {
  return typeof window !== 'undefined' && window.document && window.document.createElement;
};

var _default = isBrowserCheck;
exports["default"] = _default;